module.exports = __webpack_public_path__ + "static/media/lr.2d41daf7.svg";